import { SET_PERSISTED_AT } from "./types";

export function setPersistedAtValue(){
    return {
        type: SET_PERSISTED_AT
    };
}